export const ui = {
  expand_box: "Box ausklappen",
  collapse_box: "Box einklappen",
  collapse: "Einklappen",
  expand: "Ausklappen",
  continue: "Weiter",
  close: "Schließen",
  filter: "Filter",
  delete: "löschen",
  save: "Speichern",
  actions: "Aktionen",
  rotate: "Rotieren",
  name: "Name",
  norm: "Norm",
  field_of_law: "Rechtsgebiet",
  no_field_of_law: "Kein Rechtsgebiet",
  remove: "entfernen",
  copy: "kopieren",
  download: "herunterladen",
  copied: "kopiert",
  expand_all: "Alle ausklappen",
  all: "Alles",
  toast: {
    error: {
      error_while_syncing:
        "Fehler beim Synchronisieren. Beim nächsten Laden der Seite wird es nochmal versucht.",
    },
  },
  new_version_handler: {
    new_version_available: "Eine neue Version ist verfügbar.",
    reload: "Neu laden",
    abort: "Abbrechen",
  },
  search: {
    title: "Suche",
    feedback: "Feedback",
    laws_title: "Gesetze",
    schemata_title: "Schemata & Notizen",
    no_results: "Keine Ergebnisse gefunden",
    no_laws: "Keine Gesetze zur Suchanfrage",
    no_schemata_notes: "Keine Schemata / Notizen zur Suchanfrage",
    missing_something: "Fehlt dir etwas? Lass es uns via {feedback} wissen!",
  },
};
